<template>
   <div class="wrapper">
    <div>
        <h1 class="large-text">404</h1>
    <p>Page not found</p>
    <button>Go to home</button>
    </div>
   </div>
</template>

<script>
    export default {
           
    }
</script>

<style lang="scss" scoped>
.wrapper{
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
}
.large-text{
    font-size: 5em;
}
</style>